import { action, computed, makeObservable, observable } from 'mobx';
import { RootStore } from '@/stores';
import { CompatibilitiesStore } from '@/stores/compatibility/compatibilities';
import type { ICompatibility } from './compatibility.interface';

export class CompatibilityStore {
  @observable
  compatibility: ICompatibility;

  @computed
  get brandId(): string {
    return this.compatibility.id;
  }

  @computed
  get theme() {
    return this.compatibility.theme;
  }

  private get compatibilitiesStore(): CompatibilitiesStore {
    return this.rootStore.compatibilitiesStore;
  }

  constructor(private rootStore: RootStore) {
    makeObservable(this);
  }

  resolve(pathname: string) {
    const compatibility = this.compatibilitiesStore.resolve(pathname);
    this.setCompatibility(compatibility);
  }

  setCompatibilityById(id: string) {
    const compatibility = this.compatibilitiesStore.getCompatibilityById(id);

    if (compatibility) {
      this.setCompatibility(compatibility);
    }
  }

  @action.bound
  setCompatibility(compatibility: ICompatibility) {
    this.compatibility = compatibility;
  }
}
